import type { TagAppearance } from '@fourthwall/components'

import { type GiftCard } from '../../pages/GiftCards/GiftCards.types'

type Status = {
  label: string
  appearance: TagAppearance
}

export const STATUSES: Record<GiftCard['status'], Status> = {
  EXPIRED: {
    label: 'Expired',
    appearance: 'default',
  },
  UNUSED: {
    label: 'Unused',
    appearance: 'success',
  },
  FULLY_USED: {
    label: 'Fully used',
    appearance: 'default',
  },
  PARTIALLY_USED: {
    label: 'Partially used',
    appearance: 'success',
  },
  DEACTIVATED: {
    label: 'Deactivated',
    appearance: 'default',
  },
  ARCHIVED: {
    label: 'Archived',
    appearance: 'default',
  },
}
